// Custom packages
import { environment } from "../../../environments/environment";

/**
 * Key of the environment files that puts the entries of the 3.0.0 archive live, at the switch: the
 * links and redirects of the legacy pages (login, Home, property home…) that lead to the new pages.
 *
 * The switch (FEX-09) goes staging first: environment.staging.ts holds it as `true`, for the tests,
 * while environment.prod.ts still holds it as `false`, so the production build keeps the legacy
 * entries and the new pages stay reachable there by address only. No other environment file holds
 * it; to try the switch locally, add `archiveV3Live: true` to your own environment.local.ts, which
 * is never committed. Once staging passes it turns `true` in environment.prod.ts too; after it, the
 * legacy entries and this key are removed (FEX-28).
 *
 * @since 3.0.0
 */
export const ARCHIVE_V3_LIVE_KEY = "archiveV3Live";

/**
 * Whether the given environment puts the 3.0.0 archive live. Only the boolean `true` does: a missing
 * key, `false`, or any other value — the string "true" included — keeps the legacy entries.
 *
 * @since 3.0.0
 */
export function archiveV3LiveIn(env: { [key: string]: unknown } | null | undefined): boolean {
  return !!env && env[ARCHIVE_V3_LIVE_KEY] === true;
}

/**
 * Whether this build puts the 3.0.0 archive live, @see ARCHIVE_V3_LIVE_KEY
 *
 * @since 3.0.0
 */
export function isArchiveV3Live(): boolean {
  return archiveV3LiveIn(environment);
}
